import React, { useMemo, useState } from 'react';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { marketLabels } from '../../services/labelUtils';

function MarketDropdown({ markets, market, onChange }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);
    const icon = open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />;

    const options = useMemo(() => {
        return markets.sort();
    }, [markets]);

    const hasOptions = options.length > 1;
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (market) => {
        setAnchorEl(null);
        onChange(market);
    };

    return !hasOptions ? (
        <Typography sx={{ pr: 1, mx: 1 }}>{marketLabels[market]}</Typography>
    ) : (
        <>
            <Button
                onClick={handleOpen}
                endIcon={icon}
                sx={{
                    color: 'inherit',
                    textTransform: 'none',
                    mx: 1,
                }}
            >
                <Typography>{marketLabels[market]}</Typography>
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {options.map((item) => (
                    <MenuItem key={item} onClick={() => handleClick(item)}>
                        {marketLabels[item]}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default MarketDropdown;
